<style src="./CabineVideo.scss" lang="scss" scoped></style>
<template>
  <section class="video-call-container">
    <!-- Alerta de Permissao -->
    <AlertScreen v-if="showAlertScreen" 
      :permissionCamera='permissionCamera'
      :permissionMicrophone='permissionMicrophone'
    />

    <div class="loading-screen" v-if="loading">
      <Loading/>
      <p class="title">Aguarde... </p>
      <p>Estamos preparando tudo para você</p>
    </div>


    <!-- FULL MODAL PROTOCOL -->
    <Protocol ref="Protocol"  v-show="!enterProfessional && !professionalHasAlreadyEntered"
      :connectionLevel="connectionLevel"
      @makeProtocol="onMakeProtocol"
      @finish="onFinishProtocol"
    />



    <!-- ANTENA -->
    <div class="connection" v-show="!showAlertScreen">
      <div class="bars">
        <div class="bar one" :class="{'off': connectionLevel < 1, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
        <div class="bar two" :class="{'off': connectionLevel < 2, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
        <div class="bar three" :class="{'off': connectionLevel < 3, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
        <div class="bar four" :class="{'off': connectionLevel < 4, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
        <div class="bar five" :class="{'off': connectionLevel < 5, 'yellow': connectionColor === 'yellow', 'red': connectionColor === 'red'}"></div>
      </div>
      <div class="text"
      :class="{
        'off': connectionLevel < 1,
        'yellow': connectionColor === 'yellow',
        'red': connectionColor === 'red'}"
      >{{ connectionLabel }}</div>
    </div>

    <!-- SALA -->
    <main class="room" v-show="!showAlertScreen">
      <section class="video-screen">
        <div class="box-wait" v-show="!enterProfessional">
          <span class="text">{{ textBackground }}</span>
          <Loading/>
        </div>
        <div v-show="enterProfessional" class="expand_stream" id="expand_stream"></div>
      </section>

      <article class="video-local">
        <div class="local_stream" id="local_stream"></div>
      </article>

      <!-- btns -->
      <footer>
        <button class="button-circle" :class="{'on': isBtnMicroOn}"
          @click="onClickMicrophone" title="Ativar/Desativar Microfone"
        >
          <IconBtnMicroOff v-if="!isBtnMicroOn"/>
          <IconBtnMicroOn v-else/>
        </button>

        <button class="button-circle middle" :class="{'on': isBtnCamOn}"
                @click="onClickCamera" title="Ativar/Desativar Câmera">
          <IconBtnCamOff v-if="!isBtnCamOn"/>
          <IconBtnCamOn v-else/>
        </button>

        <button class="button-circle red" @click="onClickShowModalExit" title="Sair da chamada">
          <IconBtnExit/>
        </button>
      </footer>
      <!-- protocolo -->
      <div class="protocol" v-if="protocol">
        Protocolo: {{ protocol }}
      </div>
    </main>

    <!-- MODAL TELA SAIDA -->
    <ModalRoot :open="showModalExit">
      <ModalMain>
        <section class="modal-content">
          <main class="modal-content__main">
            <h1 class="title">Deseja sair da sala?</h1>
            <h3 class="sub-title">Realmente deseja finalizar a consulta?</h3>
            <footer class="modal-acts">
              <button class="btn-modal" @click="actExit">
                <span>Sim</span><i class="fas fa-times"></i>
              </button>
              <button class="btn-modal green" @click="onClickHideModalExit">
                <span>Voltar para a Sala</span><i class="fas fa-chevron-right"></i>
              </button>
            </footer>
          </main>
          <figure>
            <IconFigExit/>
          </figure>
        </section>
      </ModalMain>
    </ModalRoot>

    <!-- MODAL NAO SOU ROBO (temporario) -->
    <ModalRoot :open="showModalRobot && isScreenMobile">
      <ModalMain>
        <section class="modal-content">
          <main class="modal-content__main">
            <h1 class="title">Sua consulta está <span class="main">prestes a começar</span></h1>
            <h3 class="sub-title">Ao iniciar o atendimento você concorda com os nossos termos e serviços</h3>
            <h3 class="sub-title">Caso ocorra algum problema durante a consulta, entre em contato com nosso suporte.</h3>
            <footer class="modal-acts">
              <button class="btn-modal two green" @click="showModalRobot = false">
                <span>Entrar na consulta</span>
                <i class="fas fa-chevron-right"></i>
              </button>
            </footer>
          </main>
        </section>
      </ModalMain>
    </ModalRoot>
  </section>
</template>

<script>
import moment from 'moment'
import ApiService from './services/ApiService'
import FirebaseService from './services/FirebaseService'
import AgoraService from './services/AgoraService'
// import ConnectionService from "../../../services/ConnectionService"

import IconToogleCam from '@/assets/icons/IconToogleCam'
import IconBtnCamOff from '@/assets/icons/IconBtnCamOff'
import IconBtnMicroOff from '@/assets/icons/IconBtnMicroOff'
import IconBtnCamOn from '@/assets/icons/IconBtnCamOn'
import IconBtnMicroOn from '@/assets/icons/IconBtnMicroOn'
import IconBtnExit from '@/assets/icons/IconBtnExit'
import IconFigExit from '@/assets/icons/IconFigExit'
import ModalRoot from "@/components/modal/ModalRoot.vue";
import ModalMain from "@/components/modal/ModalMain.vue";
import Loading from "@/components/loading/Loading.vue";
import AlertScreen from '../alert-screen/AlertScreen'
import Protocol from './protocol/Protocol.vue'

export default {
  name: 'PortalCabineVideo',
  components: {
    Loading,
    ModalMain,
    ModalRoot,
    IconBtnMicroOff,
    IconBtnMicroOn,
    IconBtnCamOff,
    IconBtnCamOn,
    IconBtnExit,
    IconFigExit,
    IconToogleCam,
    AlertScreen,
    Protocol
  },

  data() {
    return {
      intervalCheckConnectionId: null,
      ApiService: null,
      AgoraService: null,
      ConnectionService: null,
      innerWidth: 0,
      isScreenMobile: false,

      isBtnMicroOn: true,
      isBtnCamOn: true,

      showModalExit: false,
      enterProfessional: false,
      professionalHasAlreadyEntered: false,
      titleBtnMicro: `Microfone Ativado`,
      titleBtnCam: `Câmera Ativada`,

      textBackground: 'Esperando um médico para a consulta...',

      isPreviouslyOnline: false,
      objOffline: null,
      createdAtOffline: null,

      showAlertScreen: true,
      permissionCamera: false,
      permissionMicrophone: false,

      showModalRobot: false,
      connectionColor: '',
      connectionLevel: 1,
      connectionLabel: 'Conexão Estável',

      lastSaveLogTime: null,
      cpf: null,
      qsPushToken: null,
      qsPacNome: null,
      protocol: null,
      tsaId: null,

      intervalIdCst: null,
      minutesCst: null,
      secondsCst: null,
      consultTime: null,
      waitingTime: null,
      loading: true
    }
  },

  watch: {},

  beforeDestroy() {
    // window.removeEventListener("resize", this.checkScreenSize)
  },

  async beforeMount() {
    this.checkScreenSize()
    setTimeout(() => {
      document.title = 'Portal de Teleconsulta'
    }, 500)
    // ! QueryString
    this.cpf = this.$route.query.cpf || null;
    this.qsPushToken = this.$route.query.pushToken || null
    this.qsPacNome = this.$route.query.nome || null
    if (this.cpf) {
      this.cpf = this.cpf.replace(/[.-]/g, '')
    } else {
      console.error('[CabineVideo] ERRO: queryString CPF não informado')
    }

    this.ApiService = new ApiService(this.qsPacNome)
  },

  async mounted() {
    this.updateConnectionStatus(this.connectionLevel)
    this.lastSaveLogTime = moment()

    await this.checkMediaPermissionsCamera();
    await this.checkMediaPermissionsMicrophone();
  },

  methods: {
    /**
     * Finaliza o processo do protocolo executando a ação de saída.
     */
    onFinishProtocol() {
      this.actExit();
    },

    /**
     * Define o valor do protocolo.
     * @async
     * @param {string} protocol - O protocolo gerado a ser armazenado.
     */
    async onMakeProtocol(protocol) {
      this.protocol = protocol;

      this.FirebaseService = new FirebaseService(this.protocol, this.qsPacNome)
      
      this.stopConnectionCheck()
      this.intervalCheckConnectionId = setInterval(async () => {
        await this.ApiService.checkAndSaveConnection(this.cpf, this.protocol);
      }, 1 * 60 * 1000);

      const saveMovementLog = true
      const updatLevelFirebase = true
      this.AgoraService = new AgoraService(
        this.callbackEnterProfessional,
        this.callbackTransmissionQuality,
        this.cpf,
        this.qsPacNome,
        this.protocol,
        saveMovementLog, updatLevelFirebase
      )
      this.AgoraService.setProtocol(protocol)
      await this.prepareRoom()
    },

    /**
     * Callback que atualiza a qualidade da transmissão de acordo com o nível fornecido.
     * @param {Object} quality - Objeto contendo os dados sobre a qualidade da transmissão.
     */
    callbackTransmissionQuality(quality) {
      const level = quality.level
      this.connectionLevel = level || 0
      this.updateConnectionStatus(this.connectionLevel)
    },

    /**
     * Parar o monitoramento da conexão.
     */
    stopConnectionCheck() {
      if (this.intervalCheckConnectionId) {
        clearInterval(this.intervalCheckConnectionId)
        this.intervalCheckConnectionId = null
      }
    },

    /**
     * Verifica o tamanho da tela e atualiza a variável isScreenMobile
     * com base na largura da janela. Define como true se a largura da
     * janela for menor ou igual a 1024px (tablet/celular), caso contrário,
     * define como false (monitor/desktop).
     */
    checkScreenSize() {
      this.innerWidth = window.innerWidth
      this.isScreenMobile = window.innerWidth <= 1000
    },

    /**
     * Exibe/Oculta a modal de saída.
     */
    onClickShowModalExit() {
      this.showModalExit = true
    },
    onClickHideModalExit() {
      this.showModalExit = false
    },

    /**
     * Finaliza o vídeo e emite um evento para fechar a sala.
     */
    async actExit() {
      try {
        if (this.$refs.Protocol) {
          console.warn('pegando o this.waitingTime dentro do protocol')
          this.waitingTime = this.$refs.Protocol.getWaitingTime()
        }

        console.warn('pegando o this.waitingTime', this.waitingTime)
        this.showModalExit = false
        this.FirebaseService.removeTelehealthRoom(this.cpf)
        this.stopConnectionCheck()
        this.AgoraService.closeVideo(async (status) => {
          const payloadRoom = {
            tsa_id: this.tsaId,
            tsa_tempo_espera: this.waitingTime,
            tsa_duracao_consulta: this.consultTime,
          }
          await this.ApiService.updateTeleconsultRoom(payloadRoom)
          // this.$router.push({path: "/nps", query: { protocol: this.protocol }});
          await this.FirebaseService.logout();
          this.$router.push({path: "/" });
        })
      } catch (error) {
        console.error('[FINALIZE PROTOCOL]', error)
      }
    },

    /**
     * Atualiza o status de entrada do profissional.
     * @async
     * @param {boolean} status - O novo status indicando se o profissional entrou ou não.
     */
    async callbackEnterProfessional(status) {
      if (status === true) {
        this.waitingTime = this.$refs.Protocol.getWaitingTime()
        console.warn('setando o waitingTime', this.waitingTime)
        this.startTimerCst()
      } else {
        this.cleatIntervalIdCst()
      }
      this.enterProfessional = status
      if (status === true) {
        this.professionalHasAlreadyEntered = true
      }
      // this.showModalRobot = true
      if (this.qsPushToken) {
        const obj = {
          pushTokens: [`ExponentPushToken[${this.qsPushToken}]`],
          title: 'Seu médico está pronto para te atender',
          body: 'Sua consulta está pronta! Seu médico te aguarda na sala virtual.',
          type: ''
        }
        await this.ApiService.sendNotification(obj)
      }
      this.textBackground = `O profissional está ausente agora. Se o atendimento não foi concluído, por favor, fique na sala.`
    },

    /**
     * Alterna entre a câmera frontal e traseira.
     * Este método chama o serviço de alternância de câmera do AgoraService e
     * recebe uma resposta através de um callback indicando o status da operação.
     */
    actToggleCamera() {
      this.AgoraService.toggleCamera((response) => {
        if (response.status) {
          const msg = `Câmera atual: ${response.currentCamera}`
          console.warn(msg);
        } else {
          const msg = `Erro ao alternar câmera ${response.error || response.msg}`
          console.error(msg);
          alert(msg);
        }
      });
    },

    /**
     * Alterna o estado do microfone e salva o log de ativação ou desativação.
     */
    onClickMicrophone() {
      this.isBtnMicroOn = !this.isBtnMicroOn
      this.AgoraService.audioOnOff((response) => {
        if (response.status) {
          this.audioOn = true
        } else {
          this.audioOn = false
        }
      })
    },

    /**
     * Alterna o estado da câmera e salva o log de ativação ou desativação.
     */
    onClickCamera() {
      this.isBtnCamOn = !this.isBtnCamOn
      this.AgoraService.videoOnOff((response) => {
        if (response.status) {
          this.videoOn = true
        } else {
          this.videoOn = false
        }
      })
    },

    /**
     * Prepara a sala PA (sala de atendimento profissional) encerrando o vídeo atual e criando uma nova sala.
     */
    async prepareRoom() {
      await this.AgoraService.closeVideo(async (responseCloseVideo) => {
        try {
          if (responseCloseVideo.status) {
            await this.createRoom()
          } else {
            console.error('[CabineVideo] (prepareRoom) Erro ao preparar sala')
          }
        } catch (err) {
          console.log('[FALHA AO ENTRAR NA SALA]: prepareRoom ', err)
          await this.FirebaseService.logout()
          this.$router.push({path: "/", query: { reload: 'true' }});
          this.$toast.open({
            message: 'Não foi possível criar a sala, tente novamente.',
            type: 'warning',
        });
        }
      })
    },

    /**
     * Cria uma nova sala de vídeo no Agora e
     * atualiza os dados da sala no Firebase.
     */
    async createRoom() {
      const cpfFormat = this.cpf.replace(/[.-]/g, '')
      await this.AgoraService.createRoom(cpfFormat, async (objCreateRoom) => {
        try {
          if (objCreateRoom.status) {
            this.agoraToken = objCreateRoom.agoraToken
            const channelName = objCreateRoom.agoraToken.canal
            await this.FirebaseService.setFirebaseRoom(
              cpfFormat, this.agoraToken,
              async (response)=> {
                this.tsaId = response.tsa_id
                const pacStreamId = `pacCpf_${cpfFormat}`
                await this.FirebaseService.updateFirebaseRoom(cpfFormat, 'pacStreamId', pacStreamId)
                this.listenerRoomLinkAgora(channelName)
              }
            )
          } else {
            console.error('[CabineVideo] (createRoom) Erro ao criar sala', objCreateRoom)
          }
        } catch (err) {
          console.error('[CabineVideo] (createRoom) Erro ao criar sala', objCreateRoom)
        } finally {
          this.loading = false
        }
      })
    },

    /**
     * Monitora a sala de vídeo no Firebase e exibe o modal de permissão de entrada, se necessário.
     * @param {string} channelName - O nome do canal a ser monitorado.
     */
    listenerRoomLinkAgora() {
      this.FirebaseService.listenerRoomByCpf(this.cpf, (resListener) => {
        console.log('[@DEBUG] listenerRoomLinkAgora =>', JSON.stringify(resListener, null, 2))
        if (!resListener) {
          return
        }
        if (!resListener.agoraSdk) {
          return
        }
        if (resListener.agoraSdk.pergunta === `pergunta`) {
          this.FirebaseService.updateFirebaseRoom(this.cpf, 'pergunta', 'resposta')
        }
      })
    },

    /**
     * Atualiza o status da conexão com base no nível de conexão fornecido.
     * @param {number} level - Nível da conexão (1 a 5), onde 1 e 2 são instáveis,
     * 3 é estável com aviso e 4 e 5 são estáveis.
     */
    updateConnectionStatus(level) {
      this.connectionLevel = level;
      switch (level) {
        case 1:
        case 2:
          this.connectionColor = 'red';
          this.connectionLabel = 'Conexão Instável';
          break;
        case 3:
          this.connectionColor = 'yellow';
          this.connectionLabel = 'Conexão Estável';
          break;
        case 4:
        case 5:
          this.connectionColor = '';
          this.connectionLabel = 'Conexão Estável';
          break;
        default:
          this.connectionColor = 'red';
          this.connectionLabel = 'Sem Conexão';
          break;
      }
    },

    /**
     * Verifica se a permissão de acesso à câmera está habilitada
     * e lida com erros de permissão ou ausência de câmera.
     * @async
     */
    async checkMediaPermissionsCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        console.log("Câmera está habilitada.");
        this.showAlertScreen = false
        this.permissionCamera = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        if (error.name === "NotAllowedError") {
          console.log("Acesso à câmera foi negado.");
        } else if (error.name === "NotFoundError") {
          console.log("Câmera não encontrada.");
        } else {
          console.log("Erro ao acessar a câmera: ", error);
        }
        this.showAlertScreen = true
        this.permissionCamera = false
      }
    },
    /**
     * Verifica se a permissão de acesso ao microfone está habilitada
     * e lida com erros de permissão ou ausência de microfone.
     * @async
     */
    async checkMediaPermissionsMicrophone() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        console.log("Microfone está habilitado.");
        this.showAlertScreen = false
        this.permissionMicrophone = true
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        if (error.name === "NotAllowedError") {
          console.log("Acesso à microfone foi negado.");
        } else if (error.name === "NotFoundError") {
          console.log("Microfone não encontrado.");
        } else {
          console.log("Erro ao acessar o microfone: ", error);
        }
        this.showAlertScreen = true
        this.permissionMicrophone = false
      }
    },

    // Função para iniciar o cronômetro de inicio de consulta
    startTimerCst() {
      let totalSeconds = 0;

      this.intervalIdCst = setInterval(() => {
        totalSeconds++;

        // Calcula minutos e segundos
        this.minutesCst = Math.floor(totalSeconds / 60).toString().padStart(2, "0");
        this.secondsCst = (totalSeconds % 60).toString().padStart(2, "0");
        this.consultTime = `${this.minutesCst}:${this.secondsCst}`
      }, 1000);
    },
    // Limpa o cronômetro
    cleatIntervalIdCst () {
      clearInterval(this.intervalIdCst);
    }
  }
}
</script>
